import { Box, Card, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import ServiceTable from './ServiceTable';
import ChargeDetails from './ChargeDetails';
import MissingServicesList from './MissingServicesList';

const ServiceDetails = () => {
    const [tabValue, setTabValue] = useState('0');
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    }
  return (
    <Box sx={{width:"100%"}}>
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    sx={{ p: 0, minHeight: '40px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >

                    <Tab value="0" label="Service List" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
                    <Tab value="1" label="Missing Services" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                </Tabs>
            </Box>
        </Card>
        {tabValue === '0' && <ServiceTable />}
        {tabValue === '1' && <MissingServicesList />}
    </Box>
  )
}

export default ServiceDetails
